module.exports = __webpack_public_path__ + "img/hr-fast-underground-belt-structure.92a83e1e.png";